<template>
    <div class="widget full">
        <h2 class="title">Depuis le début</h2>
        <div class="showbox" v-if="!stats.dataset">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            </div>
        </div>
        <div class="widget-content" v-if="stats.dataset">
            <div class="widget-content-datas">
                <div>
                    <div class="data-label">
                        <strong>{{ count }}</strong>
                        <span class="legend">Total des commandes</span>
                        <i class="icon icon-icon_shopping-cart"></i>
                    </div>
                </div>
                <div>
                    <div class="data-label">
                        <strong>{{ total|formatNumber }}</strong>
                        <span class="legend">Total des ventes en CHF</span>
                        <i class="icon icon-icon_money"></i>
                    </div>
                </div>
            </div>

            <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
            <!--
            <div v-for="item in stats.dataset">
                {{ item.name }} {{ item.value }}
            </div>
            -->
        </div>
    </div>
</template>
<script>

    import OrderService from './OrderService.js';
    import Bar from '../../../components/chart/Spline.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Bar
        },
        data () {
            return {
                stats: {
                    dataset: null,
                    labels: null
                },
                count: null,
                total: null,
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            categoryPercentage: 0.9,
                            barPercentage: 0.9,
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#dddddd",
                                drawBorder: false
                            },
                            ticks: {
                                display: true,
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                            },
                        }],
                        yAxes: [ {
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#dddddd",
                                borderDashOffset: 1,
                                borderDash: [2,2],
                                drawBorder: false
                            },
                            ticks: {
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                                display: true,
                                padding: 0
                                //stepSize: 1,
                                //suggestedMax: 0,
                                //suggestedMin: 0
                            }
                        }]
                    }
                }
            }
        },
        mounted: function(){
            OrderService.getStats('all').then((response) => {

                this.stats.dataset = response.data.result.stats.dataset
                this.stats.labels = response.data.result.stats.labels

                this.count = response.data.result.count
                this.total = response.data.result.total


            }).catch((response) => {
                console.log("error", response);
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/order/AllWidget.vue